import { render, staticRenderFns } from "./CalendarSlider.vue?vue&type=template&id=5d52b074&scoped=true"
import script from "./CalendarSlider.vue?vue&type=script&lang=js"
export * from "./CalendarSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d52b074",
  null
  
)

export default component.exports